// src/data/curriculum.js
const curriculum = {
  astrology: {
    title: "Vedic Astrology Mastery",
    duration: "2.5 Months",
    details: "Discover the fundamentals of Vedic Astrology and learn to interpret horoscopes, planetary influences, and cosmic patterns.",
    topics: [
      { title: "Introduction to Astrology", description: "Learn what astrology is, its history, and its relevance in modern life." },
      { title: "Planets and Their Influence", description: "Understand how planets impact personality, behavior, and destiny." },
      { title: "Zodiac Signs and Houses", description: "Study the twelve zodiac signs and twelve houses of a horoscope." },
      { title: "Creating and Reading Birth Charts", description: "Learn to construct a birth chart and interpret its key elements." },
      { title: "Yogas and Doshas", description: "Discover various yogas, doshas, and their effects on life and health." },
      { title: "Relationship of Astrology with Vastu", description: "Understand how astrology complements Vastu for better harmony." },
      { title: "Comparing Sidereal and Western Zodiacs", description: "Learn differences between the sidereal and western zodiac systems." },
      { title: "Types of Horoscopes", description: "Explore different horoscope formats: North Indian, South Indian, Bengali, and Western." },
      { title: "Advanced Chart Analysis", description: "Analyze charts to predict career, relationships, and life events." },
      { title: "Predictive Techniques", description: "Learn techniques using planetary periods and transits for predictions." }
    ]
  },

  "lal-kitab": {
    title: "Lal Kitab Remedies & Predictions",
    duration: "2 Months",
    details: "Learn the secrets of Lal Kitab, including remedies, predictions, and planetary guidance for daily life.",
    topics: [
      { title: "Introduction to Lal Kitab", description: "History and importance of Lal Kitab in astrology." },
      { title: "Planetary Remedies", description: "Learn remedies to balance planetary effects and improve life situations." },
      { title: "Horoscope Interpretation", description: "Understand Lal Kitab's approach to interpreting charts." },
      { title: "Palmistry & Lal Kitab", description: "Integrate palm reading insights with Lal Kitab teachings." },
      { title: "Doshas and Remedies", description: "Identify doshas and apply corrective remedies." },
      { title: "Practical Applications", description: "Use Lal Kitab techniques in daily life for guidance." },
      { title: "Life Predictions", description: "Make accurate predictions for health, career, and relationships." },
      { title: "Marriage and Career Insights", description: "Specialized guidance for marital compatibility and career choices." }
    ]
  },

  numerology: {
    title: "Numerology Insights",
    duration: "1.5 Months",
    details: "Understand how numbers influence your life and use numerology techniques for guidance and decision making.",
    topics: [
      { title: "History of Numerology", description: "Learn the origins and evolution of numerology across cultures." },
      { title: "Life Path Number Calculation", description: "Calculate your life path number and its significance." },
      { title: "Destiny and Soul Numbers", description: "Understand your destiny and soul numbers to unlock hidden potential." },
      { title: "Master Numbers and Meanings", description: "Explore master numbers 11, 22, 33 and their spiritual significance." },
      { title: "Practical Numerology Applications", description: "Apply numerology techniques to everyday decisions and challenges." },
      { title: "Predictive Techniques", description: "Use numerology for career, relationships, and life guidance." }
    ]
  },

  "pranic-healing": {
    title: "Pranic Healing Course",
    duration: "2 Months",
    details: "Enhance your wellbeing by learning Pranic Healing techniques to balance and energize your mind and body.",
    topics: [
      { title: "Introduction to Pranic Healing", description: "Understand the concept of prana and its role in energy healing." },
      { title: "Energy Anatomy", description: "Learn about chakras, aura, and human energy system." },
      { title: "Prana and Chakras", description: "Explore the relationship between prana flow and chakra health." },
      { title: "Healing Techniques", description: "Hands-on methods to cleanse and energize the body." },
      { title: "Meditation Practices", description: "Meditations to enhance energy balance and mindfulness." },
      { title: "Advanced Pranic Healing", description: "Advanced methods to treat complex physical and emotional issues." },
      { title: "Practical Applications", description: "Real-life uses of Pranic Healing for health and personal growth." }
    ]
  },

  "vastu-shastra": {
    title: "Vastu Shastra Guidance",
    duration: "1.5 Months",
    details: "Learn how to harmonize your environment using Vastu Shastra principles for health, wealth, and happiness.",
    topics: [
      { title: "Introduction to Vastu Shastra", description: "Understand the philosophy and benefits of Vastu." },
      { title: "Energy Flow and Directions", description: "Learn how directions influence energy in your space." },
      { title: "Vastu for Home", description: "Apply Vastu principles for rooms, furniture, and layout." },
      { title: "Vastu for Office", description: "Use Vastu for office spaces to increase productivity and positivity." },
      { title: "Remedies and Corrections", description: "Correct Vastu defects using practical remedies." },
      { title: "Practical Case Studies", description: "Analyze real-life Vastu implementations and results." }
    ]
  },

  "reiki-healing": {
    title: "Advanced Reiki Healing",
    duration: "2 Months",
    details: "Master Reiki healing techniques to restore balance and energy to the mind, body, and spirit.",
    topics: [
      { title: "Introduction to Reiki", description: "Learn the history, principles, and benefits of Reiki." },
      { title: "Energy Healing Basics", description: "Understand energy flow and basic healing methods." },
      { title: "Chakra Balancing", description: "Techniques to balance chakras and improve wellbeing." },
      { title: "Reiki Symbols and Attunements", description: "Learn symbols used in Reiki and how to receive attunements." },
      { title: "Advanced Healing Techniques", description: "Perform more complex Reiki healing sessions." },
      { title: "Hands-on Practice", description: "Practical experience in healing yourself and others." },
      { title: "Spiritual Growth", description: "Use Reiki for personal and spiritual development." }
    ]
  },

  "eft-tapping": {
    title: "EFT Tapping for Emotional Wellness",
    duration: "1 Month",
    details: "Learn Emotional Freedom Technique (EFT) to release emotional blocks and improve mental health.",
    topics: [
      { title: "Introduction to EFT", description: "Understand EFT and how it helps emotional healing." },
      { title: "Meridian Points", description: "Learn key tapping points used in EFT practice." },
      { title: "Tapping Techniques", description: "Step-by-step guidance on performing EFT correctly." },
      { title: "Stress and Anxiety Relief", description: "Use EFT to manage stress, anxiety, and negative emotions." },
      { title: "Practical Applications", description: "Apply EFT in daily life for better emotional balance." },
      { title: "Self-Healing Methods", description: "Techniques for using EFT independently for healing." }
    ]
  },

  "tarot-cards-reading": {
    title: "Tarot Card Reading",
    duration: "1.5 Months",
    details: "Develop your skills in reading Tarot cards to gain insights and guidance for yourself and others.",
    topics: [
      { title: "Introduction to Tarot", description: "Learn Tarot history, symbolism, and card structure." },
      { title: "Major Arcana", description: "Understand the meaning and significance of Major Arcana cards." },
      { title: "Minor Arcana", description: "Interpret Minor Arcana cards and suits." },
      { title: "Card Spreads", description: "Learn different Tarot spreads for guidance." },
      { title: "Interpretation Techniques", description: "Develop skills to read cards accurately." },
      { title: "Practical Readings", description: "Practice performing real-life Tarot readings." }
    ]
  },

  "kp-astrology": {
    title: "KP Astrology Expertise",
    duration: "2 Months",
    details: "Learn KP Astrology methods to make precise predictions and enhance your astrological skills.",
    topics: [
      { title: "KP System Overview", description: "Understand the KP system and its advantages." },
      { title: "Planets and Sub Lords", description: "Study planets, sub-lords, and their significance in predictions." },
      { title: "Horoscope Analysis", description: "Analyze KP horoscopes with accuracy." },
      { title: "Timing Techniques", description: "Learn methods for accurate timing of events." },
      { title: "Practical Case Studies", description: "Apply KP astrology knowledge to real-life cases." }
    ]
  },

  "akashic-records": {
    title: "Akashic Records Exploration",
    duration: "1.5 Months",
    details: "Explore your soul’s record and unlock hidden insights through Akashic Records.",
    topics: [
      { title: "Introduction to Akashic Records", description: "Learn what Akashic Records are and their importance." },
      { title: "Accessing Records", description: "Techniques to access personal and universal records." },
      { title: "Past Life Analysis", description: "Explore past life information and its impact on the present." },
      { title: "Spiritual Insights", description: "Gain guidance and insights for spiritual growth." },
      { title: "Guided Practices", description: "Practice accessing records through guided meditations." }
    ]
  },

  "nakshatra-jyotish": {
    title: "Nakshatra Jyotish Insights",
    duration: "2 Months",
    details: "Decode the 27 Nakshatras and understand their impact on your personality and destiny.",
    topics: [
      { title: "Introduction to Nakshatras", description: "Learn about the 27 Nakshatras and their characteristics." },
      { title: "Characteristics of Each Nakshatra", description: "Understand personality traits linked to each Nakshatra." },
      { title: "Influence on Life Events", description: "Study how Nakshatras affect key life events." },
      { title: "Matching Nakshatras", description: "Learn compatibility analysis using Nakshatras." },
      { title: "Practical Analysis", description: "Apply Nakshatra knowledge for predictions and guidance." }
    ]
  },

  palmistry: {
    title: "Palmistry Secrets",
    duration: "1.5 Months",
    details: "Learn professional techniques to read palms and understand life patterns, personality, and destiny.",
    topics: [
      { title: "Basics of Palmistry", description: "Introduction to palm reading and hand types." },
      { title: "Hand Shapes and Lines", description: "Identify different hand shapes and major lines." },
      { title: "Mounts and Signs", description: "Learn about mounts, signs, and their meanings." },
      { title: "Personality Analysis", description: "Interpret palm features to understand personality." },
      { title: "Future Predictions", description: "Use palmistry to predict health, career, and relationships." }
    ]
  },

  graphology: {
    title: "Graphology & Handwriting Analysis",
    duration: "1 Month",
    details: "Understand human behavior and personality traits through handwriting analysis.",
    topics: [
      { title: "Introduction to Graphology", description: "Learn the science of handwriting analysis." },
      { title: "Handwriting Traits", description: "Identify handwriting traits and their significance." },
      { title: "Personality Insights", description: "Decode personality characteristics from writing style." },
      { title: "Practical Applications", description: "Use graphology for career, relationships, and personal growth." }
    ]
  },

  "law-of-attraction": {
    title: "Law of Attraction Mastery",
    duration: "1.5 Months",
    details: "Learn how to manifest your dreams and attract positivity into your life using the Law of Attraction.",
    topics: [
      { title: "Introduction to Law of Attraction", description: "Understand the principles and science behind manifestation." },
      { title: "Visualization Techniques", description: "Learn visualization exercises to attract desires." },
      { title: "Goal Setting and Manifestation", description: "Set intentions and align actions with goals." },
      { title: "Daily Practices", description: "Incorporate practices to strengthen manifestation power." },
      { title: "Success Stories", description: "Learn from real-life examples of successful manifestations." }
    ]
  },

  "crystal-healing": {
    title: "Crystal Healing Techniques",
    duration: "1 Month",
    details: "Balance and harmonize your energy using the power of crystals for wellness and spiritual growth.",
    topics: [
      { title: "Introduction to Crystals", description: "Learn about crystals and their energy properties." },
      { title: "Types of Crystals", description: "Understand different crystals and their uses." },
      { title: "Healing Techniques", description: "Apply crystals for physical, emotional, and spiritual healing." },
      { title: "Energy Balancing Practices", description: "Techniques to harmonize your energy using crystals." }
    ]
  },

  acupressure: {
    title: "Acupressure for Mind & Body",
    duration: "1.5 Months",
    details: "Learn professional acupressure techniques to relieve stress, boost immunity, and improve overall health.",
    topics: [
      { title: "Introduction to Acupressure", description: "Understand acupressure principles and benefits." },
      { title: "Pressure Points and Techniques", description: "Locate key points and apply correct techniques." },
      { title: "Self-Healing Methods", description: "Practice acupressure to relieve common ailments." },
      { title: "Practical Applications", description: "Use acupressure in daily life for wellness and energy balance." }
    ]
  },

  "face-reading": {
    title: "Face Reading & Analysis",
    duration: "1 Month",
    details: "Decode personality traits and predict future events by learning the art of face reading.",
    topics: [
      { title: "Introduction to Face Reading", description: "Learn the basics and significance of face reading." },
      { title: "Facial Features and Analysis", description: "Analyze eyes, nose, lips, and other features for insights." },
      { title: "Personality Insights", description: "Understand personality characteristics from facial traits." },
      { title: "Predictive Techniques", description: "Use face reading to predict career, health, and relationships." }
    ]
  },

  "lo-shu-numerology": {
    title: "Lo Shu Numerology",
    duration: "1 Month",
    details: "Explore how Lo Shu numbers influence your life and learn practical applications of numerology.",
    topics: [
      { title: "Introduction to Lo Shu Numerology", description: "Understand the Lo Shu grid and its significance." },
      { title: "Lo Shu Grid and Interpretation", description: "Learn how to analyze your grid and numbers." },
      { title: "Practical Applications", description: "Use Lo Shu numerology in daily life for guidance." },
      { title: "Case Studies", description: "Review examples to understand interpretation techniques." }
    ]
  }
};

export default curriculum;
